var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AgencyService } from './../common-theme/api/agency.service';
import { OnInit, Injector } from '@angular/core';
import { HousesBaseComponent } from './../common-theme/index';
import { ActivatedRoute } from '@angular/router';
var HousesComponent = /** @class */ (function (_super) {
    __extends(HousesComponent, _super);
    function HousesComponent(injector, agencyService, route, window, document, screen) {
        var _this = _super.call(this, injector, agencyService, route, window, document) || this;
        _this.window = window;
        _this.document = document;
        _this.screen = screen;
        _this.sortItems = [
            {
                id: 'room_count',
                text: 'nr. camere'
            },
            {
                id: 'bathroom_count',
                text: 'nr. băi'
            },
            {
                id: 'size',
                text: 'suprafață'
            },
            {
                id: 'price',
                text: 'preț'
            }
        ];
        return _this;
    }
    HousesComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        if (this.screen) {
            this.pageHeight = this.screen.height - 500;
        }
        this.resetSliderSearch();
        this.route.data.forEach(function (data) {
            if (data.projects)
                _this.projects = data.projects;
            _this.projects = _this.projects.filter(function (project) {
                return project.id !== 39 && project.id !== 40;
            });
        });
        if (this.window) {
            this.window.addEventListener('scroll', this.onScroll());
        }
        this.filterSoldProjects();
    };
    HousesComponent.prototype.resetSliderSearch = function () {
        this.getPropertySearch().min_size_sqm = this.advancedLimits.min_size_sqm;
        this.getPropertySearch().max_size_sqm = 98;
        this.getPropertySearch().min_buy_price_eur = this.advancedLimits.min_buy_price_eur;
        this.getPropertySearch().max_buy_price_eur = this.advancedLimits.max_buy_price_eur;
    };
    HousesComponent.prototype.filterSoldProjects = function () {
        this.projects = this.projects.filter(function (project) {
            if (project.sale_status !== 'sold_out')
                return project;
        });
    };
    return HousesComponent;
}(HousesBaseComponent));
export { HousesComponent };



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.ts.pre-build-optimizer.js